module.exports = __webpack_public_path__ + "img/9_big.1d2b270f.png";